import MainNavigation from '../components/MainNavigation';

function ErrorPage() {
  return (
    <>
      <MainNavigation />
      <main>
        <h2>Error... </h2>
        <p>the page you are trying to access is not available</p>
      </main>
    </>
  );
}
export default ErrorPage;
